import { lazy, Suspense } from "react";

const CrmWorkspace = lazy(() => import("@mdh/ui/crm").then((module) => ({ default: module.CrmWorkspace })));

const env = (import.meta as unknown as { env?: Record<string, string | undefined> }).env ?? {};
// Docker defines this as an empty string so the CRM uses its authenticated
// origin. Local development keeps the explicit loopback fallback.
const bundledApiUrl = env.VITE_MDH_CONTROL_API_URL === undefined
  ? "http://127.0.0.1:8787"
  : env.VITE_MDH_CONTROL_API_URL.trim();
export function App() {
  return (
    <Suspense fallback={<p role="status">Loading CRM workspace…</p>}>
      <CrmWorkspace apiBaseUrl={bundledApiUrl} />
    </Suspense>
  );
}
